import { IAgreementFilterFormBooleanSelectOption } from '../interfaces/IAgreementFilterFormBooleanSelectOption';

export const agreementFilterFormBooleanSelectOptions: IAgreementFilterFormBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Да',
    value: true,
  },
  {
    id: 1,
    label: 'Нет',
    value: false,
  },
];
